import { DynamicObjectInterface } from '../type';
import { axiosDelete, axiosPost, axiosPut } from './axiosUtils';
import './axiosInterceptor';

const healthGoalService = {
  async addHealthGoal(payload: DynamicObjectInterface) {
    return await axiosPost(`healthGoal/add`, payload);
  },

  async updateHealthGoal(payload: DynamicObjectInterface) {
    return await axiosPut(`healthGoal/update`, payload);
  },

  async deleteHealthGoal(recId: DynamicObjectInterface) {
    return await axiosDelete(`healthGoal/delete/${recId}`);
  },

  async campaignQuestion(payload: DynamicObjectInterface) {
    return await axiosPost(`healthGoal/campaignQuestion`, payload);
  },

  async userAnswer(payload: DynamicObjectInterface) {
    return await axiosPost(`healthGoal/userAnswer`, payload);
  },
};
export default healthGoalService;
